<template functional>
    <div v-if="props.show" class="pricing_info" :class="props.extraClasses">
        <span class="starting_at" v-if="props.isNewEquipment && props.priceObject.main && props.priceObject.main > 0 && props.priceObject.main != 0.01">Starting At</span>
        <div class="awaiting_overlay displayed partial dots_loader" v-if="props.loading">
            <p loader="loading"></p>
        </div>
        <div v-if="props.priceObject.crossed && props.showOld && !props.loading" class="crossPriceBox onSaleBadgeMarker">
            <span class="price" v-if="props.priceObject.main && props.priceObject.main > 0 && props.priceObject.main != 0.01 && !props.loading"
                v-text="props.noCents ? $options.filters.toCurrencyNoCents(props.priceObject.main) : $options.filters.toCurrency(props.priceObject.main)"></span>
            <span class="price call_for_price" v-else>Call for Price</span>
            <span class="old_price" 
                v-text="props.noCents ? $options.filters.toCurrencyNoCents(props.priceObject.crossed) : $options.filters.toCurrency(props.priceObject.crossed)"></span>
            <span class="cross_price_break"></span>
            <span v-if="props.priceObject.saving" class="price_saving" v-text="'Save ' + $options.filters.toCurrency(props.priceObject.saving)"></span>    
            <span class="pi_onsale_badge" style="display: none">On Sale</span>
        </div>

        <div v-else >
            <span class="price" v-if="props.priceObject.main && props.priceObject.main > 0 && props.priceObject.main != 0.01 && !props.loading"
                v-text="props.noCents ? $options.filters.toCurrencyNoCents(props.priceObject.main) : $options.filters.toCurrency(props.priceObject.main)"></span>
            <span class="price call_for_price" v-else>Call for Price</span>
        </div>
    </div>
</template>

<script>
    import { getEmptyProductPrice } from "../functions/product-model";
    import '../filters/to-currency';

    export default {
        name: "PricingInfo",
        functional: true,
        props: {
            show: {
                type: Boolean,
                default: true
            },
            priceObject: {
                type: Object,
                default: getEmptyProductPrice()
            },
            extraClasses: {
                type: String,
                default: ''
            },
            showOld: {
                type: Boolean,
                default: true
            },
            loading: {
                type: Boolean,
                default: false
            },
            isNewEquipment: {
                type: Boolean,
                default: false
            },
            noCents: {
                type: Boolean,
                default: false
            },
        },
    };
</script>